import { render, staticRenderFns } from "./scope-add.vue?vue&type=template&id=5f73582e&scoped=true&"
import script from "./scope-add.vue?vue&type=script&lang=js&"
export * from "./scope-add.vue?vue&type=script&lang=js&"
import style0 from "./scope-add.vue?vue&type=style&index=0&id=5f73582e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73582e",
  null
  
)

export default component.exports